<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Provinsi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="provinsiList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="province"
          label="name"
          v-model="provinsiId"
          placeholder="Pilih Provinsi"
        />
        <span class="text-danger text-sm">{{ errors.first("province") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kabupaten/Kota</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :disabled="provinsiId === null"
          :options="kabKotList"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="kab/kot"
          label="name"
          v-model="formData.kabkot_id"
          placeholder="Pilih Kabupaten/Kota"
        />
        <span class="text-danger text-sm">{{ errors.first("kab/kot") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Kecamatan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="kab/kot name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Kabupaten/Kota"
        />
        <span class="text-danger text-sm">{{ errors.first("kab/kot name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Latitude</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="latitude"
          class="w-full sidebar-input"
          v-model="lat"
          placeholder="Isi Dengan Latitude"
        />
        <span class="text-danger text-sm">{{ errors.first("latitude") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Longitude</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="longitude"
          class="w-full sidebar-input"
          v-model="long"
          placeholder="Isi Dengan Longitude"
        />
        <span class="text-danger text-sm">{{ errors.first("longitude") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  components: {
    flatPickr,
  },
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      emptyImage,
      url,
      subKategoriList: [],
      kabKotList: [],
      lat: "",
      long: "",
      provinsiId: null,
      meta: null,
      formData: {
        kabkot_id: null,
        name: "",
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Kabupaten/Kota" : "Tambah Kabupaten/Kota";
    },
    kabKotId() {
      return this.formData.kabkot_id;
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    provinsiList() {
      return this.$store.state.wilayah.provinsiList;
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.kabkot_id !== null &&
        this.formData.name !== "" &&
        this.lat !== "" &&
        this.long !== ""
      );
    },
    profile() {
      return this.$store.state.auth.profileAccess.profile;
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    provinsiId() {
      if (this.provinsiId !== null) {
        this.kabKotList = this.$store.getters["wilayah/getFilteredKabKot"](
          this.provinsiId
        );
        if (this.formData.kabkot_id !== null) {
          if (
            this.kabKotList.find((v) => v.id === this.formData.kabkot_id) === undefined
          ) {
            this.formData.kabkot_id = null;
          }
        }
      } else {
        this.formData.kabkot_id = null;
      }
    },
    kabKotId() {
      if (this.formData.kabkot_id === null) {
        this.provinsiId = null;
      }
    },
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        (this.lat = this.passData.meta
          ? this.quoteFormat(this.passData.meta.lat)
            ? this.quoteFormat(this.passData.meta.lat)
            : ""
          : ""),
          (this.long = this.passData.meta
            ? this.quoteFormat(this.passData.meta.long)
              ? this.quoteFormat(this.passData.meta.long)
              : ""
            : ""),
          (this.formData.provinsi_id = this.passData.provinsi
            ? this.passData.provinsi.id
            : null)(
            (this.meta = this.passData.meta ? this.quoteFormat(this.passData.meta) : "")
          );
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    quoteFormat(text) {
      return JSON.stringify(text);
    },
    resetForm() {
      this.formData.name = "";
      this.meta = null;
      this.long = "";
      this.lat = "";
      this.formData.provinsi_id = null;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.meta = {
        lat: this.lat,
        long: this.long,
      };

      // if (this.checkCategory) {
      //   this.formData.kat_id = this.$store.state.zis.kategoriList.find(
      //     (v) => v.name === "Zakat" || v.name === "Zakat Fitrah"
      //   ).id;
      //   this.formData.sub_id = this.$store.state.zis.subKategoriList.find(
      //     (v) => v.name === "Zakat Fitrah"
      //   ).id;
      // }
      this.$store
        .dispatch("wilayah/cudKecamatan", [
          { ...this.formData, meta: this.meta.toString(), ...id },
        ])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Kecamatan Sukses!"
                : "Tambah Kecamatan Sukses!",
            text:
              this.passData !== null
                ? `Kecamatan ${v.name} Berhasil diedit`
                : `Kecamatan ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>

<style scoped>
.text-red {
  color: red;
}
.text-blue {
  color: blue;
}
.text-grey-black {
  color: rgb(70, 70, 70);
}
img {
  max-height: 400px;
  overflow: auto;
}
</style>
